<template>
    <div class="text-ihh-midnight-gray min-h-screen">
        <div class="flex justify-center text-3xl font-semibold tracking-wider">{{ search.results?.length}} results for '{{ search.value }}'</div>
        <div class="w-full mt-12" v-if="search?.results?.length">
            <div class="grid grid-cols-4 gap-4 md:gap-8 px-8">
                <Product v-for="item in search.results" :product="item" :key="item.id" />
            </div>
        </div>
    </div>
</template>

<script>
import Mango from '../../helpers/mango'
import Product from '../products/product.vue'

export default {
    components: { Product },
    data() {
        return {
            searchTimeout: null,
            keyListener: null,
            search: {
                activeIndex: 0,
                value: null,
                results: [],
                categories: [],
                loading: false,
            }
        }
    },

    mounted() {
        this.search.value = this.$route?.query?.searchValue
        if (this.search.value?.length) {
            this.searchMango()
        }
    },

    methods: {
        async searchMango() {
            console.log('searching')
            this.search.categories = await Mango.search(this.search.value, {limit: 5}, 'isVisible:true AND collection:categories')
            console.log("found: ", this.search.categories)
            this.search.results = await Mango.search(this.search.value, {limit: 25}, 'isVisible:true AND availability:available')
        },
    },
}
</script>
